import React, { useState } from "react";
import VisitesLineChart from "./VisitesLineChart";
import { useUser } from "./../../contexts/UserContext";
import { getRoleFromRoleId } from "./../../utils/roleHelper";
import useScrollToTop from "../../hooks/useScrollToTop";
import MessagesSection from "./MessagesSection"; // ⬅️ NEW
import AbonnementsCards from "./AbonnementsCards"; // ⬅️ NEW
import PaymentsTable from "./PaymentsTable";
import UsersStatCard from "./UsersStatCard";
import CompetitionsStatCard from "./CompetitionsStatCard"; // ⬅️ NEW
import CompetiteursStatCard from "./CompetiteursStatCard";
import DistributionsStatCard from "./DistributionsStatCard";
import CombatsStatCard from "./CombatsStatCard";

const Dashboard = () => {
  useScrollToTop();
  const [usersCount] = useState(0);
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);
  const userId = user?.userId;

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        ADMINISTRATEUR
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-montserrat uppercase">
        Dashboard
      </h2>

      {/* 🔹 Abonnements / Formules */}
      <div className="w-full max-w-6xl px-2 mx-auto mb-8">
        <AbonnementsCards />
      </div>

      {/* Table des paiements */}
      <div className="w-full max-w-6xl px-2 mx-auto mb-8">
        <PaymentsTable />
      </div>

      {/* Statistiques */}
      <div className="w-full max-w-6xl px-2 mx-auto mb-6">
        {/* Grille prévue pour accueillir d'autres cards plus tard */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <UsersStatCard />
          <CompetitionsStatCard />
          <CompetiteursStatCard />
          <DistributionsStatCard />
          <CombatsStatCard />
          {/* ⬇️ Tu pourras ajouter ici d'autres cards (Compétitions, Combats, etc.) */}
        </div>
      </div>

      {/* Graphique visites */}
      <div className="flex flex-col items-center w-full px-4 mt-4 font-montserrat">
        <div className="w-full max-w-4xl px-2 mb-8">
          <VisitesLineChart />
        </div>

        {/* Messages ContactForm */}
        <div className="w-full max-w-6xl px-2 mb-8">
          <MessagesSection />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
